import { render } from "./AddCase.vue?vue&type=template&id=058ee30e&scoped=true"
import script from "./AddCase.vue?vue&type=script&lang=ts"
export * from "./AddCase.vue?vue&type=script&lang=ts"

import "./AddCase.vue?vue&type=style&index=0&id=058ee30e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-058ee30e"

export default script